/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, web and mobile offerings; check the edition for your device.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供桌面、网页及移动端产品，需要按设备核对版本。`)
};

/**
* | output |
* | --- |
* | "Desktop, web and mobile offerings; check the edition for your device." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_2 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.4.2" }